import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { HOME_SEO_PATHS } from "../seo/homeRoutesMeta";

const routes: RouteObject[] = [
  ...HOME_SEO_PATHS.map((path) => ({
    path,
    element: <Home />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
